(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-opus-navigation-base"] && !Shopify.designMode) return;
  try {
    if (!globalThis.ccOpusNavigationBound) {
    globalThis.ccOpusNavigationBound = true;

    document.addEventListener('keydown', (event) => {
      const summary = event.target.closest('.cc-opus-nav summary');
      if (summary && (event.key === 'Enter' || event.key === ' ')) {
        const disclosure = summary.parentElement;
        disclosure.open = !disclosure.open;
        event.preventDefault();
        return;
      }

      if (event.key !== 'Escape') return;

      const disclosure = event.target.closest('.cc-opus-nav details[open]');
      if (!disclosure) return;

      const disclosureSummary = disclosure.querySelector(':scope > summary');
      disclosure.removeAttribute('open');
      disclosureSummary?.focus();
      event.preventDefault();
    });

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.cc-opus-nav__details > summary');
      if (!summary) return;

      document.querySelectorAll('.cc-opus-nav__details[open]').forEach((disclosure) => {
        if (disclosure !== summary.parentElement) disclosure.removeAttribute('open');
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (event.target.closest('.cc-opus-nav__details')) return;
      document.querySelectorAll('.cc-opus-nav__details[open]').forEach((disclosure) => {
        disclosure.removeAttribute('open');
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-opus-navigation-coverage"] && !Shopify.designMode) return;
  try {
    if (!globalThis.ccOpusNavigationBound) {
    globalThis.ccOpusNavigationBound = true;

    document.addEventListener('keydown', (event) => {
      const summary = event.target.closest('.cc-opus-nav summary');
      if (summary && (event.key === 'Enter' || event.key === ' ')) {
        const disclosure = summary.parentElement;
        disclosure.open = !disclosure.open;
        event.preventDefault();
        return;
      }
      if (event.key !== 'Escape') return;
      const disclosure = event.target.closest('.cc-opus-nav details[open]');
      if (!disclosure) return;
      const disclosureSummary = disclosure.querySelector(':scope > summary');
      disclosure.removeAttribute('open');
      disclosureSummary?.focus();
      event.preventDefault();
    });

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.cc-opus-nav__details > summary');
      if (!summary) return;
      document.querySelectorAll('.cc-opus-nav__details[open]').forEach((disclosure) => {
        if (disclosure !== summary.parentElement) disclosure.removeAttribute('open');
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (event.target.closest('.cc-opus-nav__details')) return;
      document.querySelectorAll('.cc-opus-nav__details[open]').forEach((disclosure) => disclosure.removeAttribute('open'));
    });
  }
  } catch(e) { console.error(e); }
})();

})();
